import { queueMetaBrowserEvent } from '../api';

export const META_PIXEL_ID = '932495466327560';
const CONSENT_KEY = 'wearhouse60_marketing_consent';

export const hasMarketingConsent = () => typeof window !== 'undefined' && localStorage.getItem(CONSENT_KEY) === 'granted';

export const createMetaEventId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return `meta_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
};

export const metaTrack = (event, params = {}, eventId) => {
  if (!hasMarketingConsent() || typeof window.fbq !== 'function') return false;
  const options = eventId ? { eventID: eventId } : undefined;
  window.fbq('trackSingle', META_PIXEL_ID, event, params, options);
  return true;
};

export const storeMarketingConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value ? 'granted' : 'denied');
  if (typeof window.fbq === 'function') window.fbq('consent', value ? 'grant' : 'revoke');
};

export const getMarketingConsentChoice = () => (typeof window === 'undefined' ? null : localStorage.getItem(CONSENT_KEY));

export const trackMetaCommerceEvent = (event, params, serverEvent) => {
  if (!hasMarketingConsent()) return null;
  const eventId = createMetaEventId();
  metaTrack(event, params, eventId);
  queueMetaBrowserEvent({
    event_name: event,
    event_id: eventId,
    event_source_path: window.location.pathname,
    consent: true,
    ...serverEvent,
  }).catch(() => {});
  return eventId;
};